export default __webpack_public_path__ + "static/media/veh-11.05adcac6.png";